import { RouteObject } from 'react-router-dom';
import MainLayoutProvider from '../providers/MainLayoutProvider';
import AuthGuard from '../utils/route-guard/AuthGuard';
import MainLayout from '../layouts/MainLayout';
import { lazy, Suspense } from 'react';
import PhoenixLoader from '../components/common/PhoenixLoader';

const EncounterFormPage = lazy(
  () => import('components/forms/encounter-management')
);
const EncounterAnalyticPage = lazy(
  () => import('pages/encounter-management/EncounterAnalyitcPage')
);

const EncounterManagementRoutes: RouteObject = {
  path: '/encounter-management/',
  element: (
    <MainLayoutProvider>
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    </MainLayoutProvider>
  ),
  children: [
    {
      path: 'encounter-form/:id/:name',
      index: true,
      element: (
        <Suspense fallback={<PhoenixLoader />}>
          <EncounterFormPage />
        </Suspense>
      )
    },
    {
      path: 'analytic',
      index: true,
      element: (
        <Suspense fallback={<PhoenixLoader />}>
          <EncounterAnalyticPage />
        </Suspense>
      )
    }
  ]
};

export default EncounterManagementRoutes;
